// extracted by mini-css-extract-plugin
export var logo = "Logo-module--logo--5Oevj";
export var logo_size_small = "Logo-module--logo_size_small--PefhY";
export var logo_isLink = "Logo-module--logo_isLink--oUill";
export var logo_active = "Logo-module--logo_active--toRDb";
export var logo__img = "Logo-module--logo__img--bttFH";
export var logo__visuallyHiddenEl = "Logo-module--logo__visuallyHiddenEl--flwwL";